

import React from 'react'
import Navbar from "../../LandingPage/Navbar/Navbar"
import EdofSection1 from '../../EdofSectionNew2/EdofSection1/EdofSection1';
import EdofSection2 from '../../EdofSectionNew2/EdofSection2/EdofSection2';
import EdofSection3 from '../../EdofSectionNew2/EdofSection3/EdofSection3';
import EdofSection4 from '../../EdofSectionNew2/EdofSection4/EdofSection4';
import EdofSection5 from '../../EdofSectionNew2/EdofSection5/EdofSection5';
import EdofSection6 from '../../EdofSectionNew2/EdofSection6/EdofSection6';
import EdofSection7 from '../../EdofSectionNew2/EdofSection7/EdofSection7';
import EdofSection8 from '../../EdofSectionNew2/EdofSection8/EdofSection8';
import EdofSection9 from '../../EdofSectionNew2/EdofSection9/EdofSection9';
import EdofSection10 from '../../EdofSectionNew2/EdofSection10/EdofSection10';
import EdofSection11 from '../../EdofSectionNew2/EdofSection11/EdofSection11';
import EdofSection12 from '../../EdofSectionNew2/EdofSection12/EdofSection12';
import Footer2 from '../../Footer2/Footer2';
import TopBar from "../../EdofSectionNew2/TopBar/TopBar";
const EdofPageNew2 = () => {
    return (
        <div>
            <TopBar />
            <Navbar />
            <EdofSection1 />
            <EdofSection2 />
            <EdofSection3 />
            <EdofSection4 />
            <EdofSection5 />
            <EdofSection6 />
            <EdofSection7 />
            {/* Swap Section8 and Section9 on mobile */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <div style={{ order: 2 }} className="section8-wrapper">
                    <EdofSection8 />
                </div>
                <div style={{ order: 1 }} className="section9-wrapper">
                    <EdofSection9 />
                </div>
            </div>
            <EdofSection10 />
            <EdofSection11 />
            <EdofSection12 />
            <Footer2 />
        </div>
    )
}

export default EdofPageNew2
